<template>
  <div id="totalBox">
    <div class="featuresBox">
      <p class="featuresTitle">功能特点</p>
      <div class="bottomLine"></div>
      <div class="featuresListBox">
        <ul class="featuresList">
          <li class="featuresTitle">电子支付</li>
          <li class="featuresContent">支持微信</li>
          <li class="featuresContent">支付宝</li>
          <li class="featuresContent">银行卡快捷支付</li>
          <li class="featuresContent">大大提高通行效率</li>
        </ul>
        <ul class="featuresList">
          <li class="featuresTitle">云计算</li>
          <li class="featuresContent">灵活性</li>
          <li class="featuresContent">多配置</li>
          <li class="featuresContent">可用性</li>
          <li class="featuresContent">降低成本</li>
          <li class="featuresContent">动态扩充性强</li>
        </ul>
        <ul class="featuresList">
          <li class="featuresTitle">室内定位导航</li>
          <li class="featuresContent">二级导航精准车位</li>
        </ul>
        <ul class="featuresList">
          <li class="featuresTitle">大数据</li>
          <li class="featuresContent">数据统一管理</li>
          <li class="featuresContent">统一分析</li>
        </ul>
        <ul class="featuresList">
          <li class="featuresTitle">社交属性</li>
          <li class="featuresContent">支持用户点评</li>
          <li class="featuresContent">传播和分享</li>
        </ul>
        <ul class="featuresList">
          <li class="featuresTitle">OPENAPI</li>
          <li class="featuresContent">支持APP嵌入</li>
          <li class="featuresContent">微信公众号嵌入</li>
          <li class="featuresContent">H5嵌入</li>
          <li class="featuresContent">WEB嵌入</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Features',
  data: function () {
    return {
      msg: '1',
      carouselIndex: 1,
      timeInterval: 0
    }
  }
}
</script>

<style scoped>
#totalBox{
  width: 100%;
  height: 340px;
}
.featuresBox{
  width: 1200px;
  height: 30px;
  margin:  0 auto;
  padding-top: 30px;
}
.featuresTitle{
  text-align:center;
  font-size:30px;
  font-weight:bold;
  color:rgba(35,24,21,1);
  line-height:36px;
}
.bottomLine{
  width: 40px;
  height: 4px;
  margin: 0 auto;
  margin-top: 10px;
  background-color: RGBA(255, 182, 30, 1);
}
.featuresListBox{
  width: 100%;
  height: 170px;
  margin-top: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.featuresList{
  width: 200px;
  height: 100%;
  border-right: 1px solid rgba(223,223,223,1);
}
.featuresList:first-of-type{
  border-left: 1px solid rgba(223,223,223,1);
}
.featuresTitle{
  font-size:18px;
  font-weight:bold;
  color:rgba(35,24,21,1);
  line-height:36px;
  text-align: center;
  margin-bottom: 10px;
}
.featuresContent{
  font-size:14px;
  font-weight:400;
  color:rgba(117,117,117,1);
  line-height:25px;
}
</style>



// WEBPACK FOOTER //
// src/components/plan/features.vue